import { render, staticRenderFns } from "./ReportNote.vue?vue&type=template&id=76663f10&"
import script from "./ReportNote.vue?vue&type=script&lang=js&"
export * from "./ReportNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports